module.exports = __webpack_public_path__ + "static/media/dollar.fa38d3ff.png";